import Icon from '../components/Icon.vue'

Icon.register({
  'sad-tear': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM328 176C345.7 176 360 190.3 360 208S345.7 240 328 240 296 225.7 296 208 310.3 176 328 176zM152 416C125.5 416 104 395 104 369 104 349 132.5 308.6 145.6 291.2 148.8 286.9 155.2 286.9 158.4 291.2 171.5 308.6 200 349 200 369 200 395 178.5 416 152 416zM168 240C150.3 240 136 225.7 136 208S150.3 176 168 176 200 190.3 200 208 185.7 240 168 240zM338.2 394.2C315.8 367.4 282.9 352 248 352 226.8 352 226.8 320 248 320 292.4 320 334.3 339.6 362.7 373.8 376.5 390.2 351.5 410.3 338.2 394.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sad-tear.js
// module id = l0xI
// module chunks = 144